/* global flatpickr, I18n */

import ApplicationController from '../application_controller'
import rangePlugin from 'flatpickr/dist/plugins/rangePlugin.js'
import { parseFlexibleDate } from '../../lib/parseFlexibleDate'

class RangeSelectController extends ApplicationController {
  static targets = ['rangeStart', 'rangeEnd']

  connect () {
    flatpickr.l10ns[I18n.locale].firstDayOfWeek = 1
    flatpickr.localize(flatpickr.l10ns[I18n.locale])

    this.picker = flatpickr(this.rangeStartTarget, {
      dateFormat: 'd.m.Y',
      allowInput: true,
      parseDate: parseFlexibleDate,
      position: 'auto center',
      plugins: [rangePlugin({ input: this.rangeEndTarget })]
    })

    this.keepEndDateWhenCommittingStartInput()
  }

  disconnect () {
    this.picker?.destroy()
  }

  keepEndDateWhenCommittingStartInput () {
    const setDate = this.picker.setDate.bind(this.picker)
    const separator = this.picker.l10n.rangeSeparator

    this.picker.setDate = (date, triggerChange, format) => {
      if (typeof date === 'string' && date.trim() && !date.includes(separator)) {
        setDate(this.keepValidDates([date, this.rangeEndTarget.value]), false, format)
        this.notifyValueUpdate()
        return
      }

      if (Array.isArray(date)) return setDate(this.keepValidDates(date), triggerChange, format)

      return setDate(date, triggerChange, format)
    }
  }

  keepValidDates (values) {
    return values.map((value, index) => {
      if (typeof value !== 'string' || !value.trim() || parseFlexibleDate(value)) return value

      return this.picker.selectedDates[index]
    })
  }

  notifyValueUpdate () {
    const { selectedDates, input, config } = this.picker

    config.onValueUpdate.forEach((hook) => hook(selectedDates, input.value, this.picker))
  }
}

export default RangeSelectController
